/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-rime-reveal.js — page-wide slow reveal/hide for the RIME AERO page.
   Gate (same as qp-rime-intro.js): IO present, reduced motion off, not the
   theme editor. An inline gate in qp-rime-hero.liquid adds the html class
   before later sections paint (and drops it after 3s if this file never ran);
   all hidden states live under html.qp-rime-reveal-ready in qp-rime-reveal.css.
   Targets every .shopify-section in #MainContent except the hero. Toggles
   `is-in` both ways: in at ratio >= 0.12 (or any overlap when taller than the
   viewport), out only once fully off-screen. Any error drops the gate. */
(function (win) {
  'use strict';
  if (win.__qpRimeReveal) return;
  win.__qpRimeReveal = true;
  var doc = win.document, root = doc.documentElement, READY = 'qp-rime-reveal-ready', io = null;

  function fail() { root.classList.remove(READY); }

  function canAnimate() {
    if (!('IntersectionObserver' in win)) return false;
    if (win.Shopify && win.Shopify.designMode) return false;
    return !(win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function targets() {
    var main = doc.getElementById('MainContent') || doc.querySelector('main');
    if (!main) return [];
    return Array.prototype.filter.call(main.querySelectorAll('.shopify-section'), function (s) {
      return !s.querySelector('.qp-rime-hero');
    });
  }

  // in: >=12% visible, or taller than the viewport and overlapping at all.
  function apply(el, top, bottom, height) {
    var vh = win.innerHeight || root.clientHeight;
    var seen = Math.min(bottom, vh) - Math.max(top, 0);
    if (seen <= 0) { el.classList.remove('is-in'); return; }
    if (height > vh || seen / Math.max(height, 1) >= 0.12) el.classList.add('is-in');
  }

  function onEntries(entries) {
    try {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { e.target.classList.remove('is-in'); return; }
        var r = e.boundingClientRect;
        apply(e.target, r.top, r.bottom, r.height);
      });
    } catch (err) { fail(); }
  }

  function recheck() {
    try {
      targets().forEach(function (el) {
        var r = el.getBoundingClientRect();
        apply(el, r.top, r.bottom, r.height);
      });
    } catch (err) { fail(); }
  }

  function init() {
    try {
      if (!canAnimate() || win.__qpRimeRevealGate === -1) { fail(); return; }
      root.classList.add(READY);
      if (!io) io = new win.IntersectionObserver(onEntries, { threshold: [0, 0.12] });
      targets().forEach(function (el) {
        if (el.hasAttribute('data-qp-reveal')) return;
        el.setAttribute('data-qp-reveal', '');
        io.observe(el);
      });
    } catch (err) { fail(); }
  }
  var t;
  win.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(recheck, 150); });
  win.addEventListener('pageshow', function () { init(); recheck(); });
  win.addEventListener('hashchange', recheck);
  doc.addEventListener('shopify:section:load', init);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();
})(window);
